import React from 'react';
import { HomeScreen as View } from './View';
import { getPromotions, getConsumerRewardOptInStatus } from 'context/mockData/data';
import { useUser } from 'context';
export var HomeScreenContainer = function () {
    var account = useUser().account;
    return (React.createElement(View, { pricingModel: (account === null || account === void 0 ? void 0 : account.pricingModel) || '', promotions: getPromotions === null || getPromotions === void 0 ? void 0 : getPromotions.promotions, consumerRewardsInfo: getConsumerRewardOptInStatus, isLoading: false }));
};
